// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"ca594518","213":"0dcbff02","247":"9f2870fb","553":"bc44dfee","627":"3c410d4c","834":"ab7f2675","867":"90ff6392","923":"b4207b7f","938":"f038476d"}[chunkId] + ".chunk.js";
};